// ============================================================================
// OfflineDataBanner — «данные из кэша» (ЕДИНЫЙ вид для всех экранов, SSoT/SRP).
// Показывается, когда последнее чтение экрана отдано из сохранённого кэша
// (offlineCache.readThrough → useOfflineDataStore по ключу-источнику).
// ============================================================================
import { WifiOff } from 'lucide-react';
import { useOfflineDataStore } from '@/lib/offlineCache';

export function OfflineDataBanner({ sourceKey }: { sourceKey: string }) {
  const savedAt = useOfflineDataStore((s) => s.stale[sourceKey]);
  if (!savedAt) return null;
  const when = new Date(savedAt).toLocaleString('ru-RU', { dateStyle: 'short', timeStyle: 'short' });
  return (
    <div className="flex items-center gap-2 rounded-md border border-amber-500/40 bg-amber-500/10 px-2.5 py-1.5 text-[11px] text-amber-700 shrink-0">
      <WifiOff className="h-3.5 w-3.5 shrink-0" />
      <span>Офлайн: показаны сохранённые данные (обновлено {when})</span>
    </div>
  );
}
